module.exports = __webpack_public_path__ + "static/media/me.5ede0fe1.png";